export enum EnumSituacaoCondicaoPagamento {
  ATIVA = 1,
  INATIVA = 2,
  CLIENTE = 3,
}
